import { apiClient } from '../../../../api/axios';
import type { ApiResponse, PaginatedResponse } from '../common/types';
import type { ReviewDecision, GetReviewDecisionsPayload } from './types';

export const reviewDecisionService = {
    getAllReviewDecisions: async (
        payload: GetReviewDecisionsPayload
    ): Promise<ApiResponse<PaginatedResponse<ReviewDecision>>> => {
        const requestPayload = {
            pageNumber: payload.pageNumber,
            pageSize: payload.pageSize,
            sortBy: payload.sortBy ?? '',
            sortDescending: payload.sortDescending ?? true,
            categoryId: payload.categoryId ?? 0,
            cycleId: payload.cycleId ?? 0,
            applicationType: payload.applicationType ?? 0,
            requireReconciliation: payload.requireReconciliation ?? false,
        };
        const response = await apiClient.post('/Reviews/GetReviewDecision', requestPayload);
        return response.data;
    },

    allowReconciliation: async (submissionId: string): Promise<ApiResponse<boolean>> => {
        const response = await apiClient.post(
            '/ReviewAssignments/AllowReconciliation',
            JSON.stringify(submissionId),
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    },
};
